import { HeroUIPluginConfig } from "@heroui/react";
import { colors } from "./colors";
export const theme: HeroUIPluginConfig = {
  layout: {
    radius: {
      small: "0.25rem",
      medium: "0.5rem",
      large: "0.75rem",
    },
    borderWidth: {
      small: "0.5px",
      medium: "1px",
      large: "2px",
    },
  },
  themes: {
    light: {
      colors: {
        primary: {
          ...colors.primary,
          DEFAULT: colors.primary["500"],
        },
        success: {
          foreground: "#ffffff",
          DEFAULT: "#12a150",
        },
      },
    },
  },
};
